import Link from "shared/components/navigation/links/Link";
import PropTypes from "prop-types";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import { BreadcrumbArrowIcon, BreadcrumbLI, BreadcrumbUL } from "./Breadcrumb.styles";

const Breadcrumb = ({ menuOptions }) => {
    return (
        <BreadcrumbUL>
            {menuOptions.map((data) => (
                <BreadcrumbLI
                    key={data.to ?? data.href ?? data.children}>

                    {data.to || data.href || data.disabled
                        ? (<Link {...data} />)
                        : (<Text color="Gray_2" variant="Body_2_2" {...data} />)}

                    <BreadcrumbArrowIcon name="caret-right" color="Gray_4" />
                </BreadcrumbLI>
            ))}
        </BreadcrumbUL>
    );
};

Breadcrumb.propTypes = {
    menuOptions: PropTypes.array,
};

export default Breadcrumb;
